import CanvasObject from './CanvasObject';
import { roundRect, allInside, verticeOverlap, anyLineIntersect, diagonalIntersect, isSmallSignature } from './canvas-helper';
import { STOCK_IMAGE, CUSTOM_IMAGE, IMAGE, LOGO } from './itemTypes';
import RedCros from '../../img/red-cross.png';

class ImageItem extends CanvasObject {

	constructor(ctx, image, options = {}) {
		super();
		this.ctx = ctx;
		this.isMetalSkin = options.isMetalSkin;
		this.itemArea = options.itemArea;
		this.canvasScale = options.canvasScale;

		this.coverageArea = options.coverageArea;
		this.signatureAbsoluteCoverageArea = options.signatureAbsoluteCoverageArea;
		this.allowedArea = options.allowedArea;
		this.initialPos = options.initialPosition;

		//allow for portrait mode -----------------------
		this.coverageArea = {
			x: options.coverageArea.x,
			y: options.coverageArea.y,
			width: (options.isPortrait)? options.coverageArea.height : options.coverageArea.width,
			height: (options.isPortrait)? options.coverageArea.width : options.coverageArea.height
		}
		this.width = options.width || 50;
		this.height = options.height || 50;

		this.layerType = options.layerType || STOCK_IMAGE;
		// this.type = options.type || IMAGE;
		this.type = options.type || image.activeMode;

		this.id = image.id;
		
		// this.rotation = 90;

		const bleeding = options.bleeding || 5;

		this.borderColor = options.borderColor || 'rgb(49, 183, 219)';
		this.defaultColor = '#FFFFFF';

		this.removed = false;

		this.setImage(image.url, this.layerType);

		// remove icon (red cross shown when item moved out from allowedArea)
		const removedIcon = new Image();
		removedIcon.src = RedCros;
		removedIcon.onload = () => {
			this.removedIcon = removedIcon;
		};
	}

	reset(resetObj) {
		if (this.locked) {
			return;
		}

		// Scale reset
		this.width = resetObj.width;
		this.height = resetObj.height;

		// Rotate reset
		this.rotation = resetObj.rotation;

		// Move reset
		this.originPoint.x = resetObj.originPoint.x;
		this.originPoint.y = resetObj.originPoint.y;
	}
	
	setImage(url, imageType) {

		this.layerType = imageType;

		const img = new Image();
		img.crossOrigin = 'Anonymous';
		img.src = url;

		return new Promise(resolve => {
			img.onload = () => {
				this.image = img;
				this.selected = true;
				// Aligning the image at (center) position in Metal skin only
				if(this.isMetalSkin) {
					this.originPoint = {
						x: this.coverageArea.x + (this.coverageArea.width / 2),
						y: this.coverageArea.y + (this.coverageArea.height / 2)
					};
				}
				else{

					if(this.initialPos){
						this.originPoint = {
							x: this.initialPos.x,
							y: this.initialPos.y
						};
					} else {
						// align the image at (0,0) position
						this.originPoint = {
							x: this.coverageArea.x + this.width / 2,
							y: this.coverageArea.y + this.height / 2
						};
					}
				}
				
				//fit image to max dimension of 50px (arbitary default value) ----------------
				if(! this.isMetalSkin) {
					const aRatio = img.naturalWidth / img.naturalHeight; //image's actual dimensions

					const scaledDefault = (this.canvasScale)? 50 * this.canvasScale : 50;

					this.height = (aRatio > 1)? (scaledDefault / aRatio) : scaledDefault;
					this.width = (aRatio > 1)?  scaledDefault : (scaledDefault * aRatio);
				}
				resolve(this.image)
			};

		});

	}

	render(ctx) {
		if (!this.image) {
			return;
		}

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		// show item coverage area
		if (this.selected) {
			ctx.save();
			ctx.translate(canvasCenter.x, canvasCenter.y);
			roundRect(ctx, this.coverageArea.x, this.coverageArea.y, this.coverageArea.width, this.coverageArea.height, 2);
			
			ctx.restore();
		}
		ctx.save();
		ctx.translate(this.originPoint.x + canvasCenter.x, this.originPoint.y + canvasCenter.y);
		if (this.rotation !== 0) {
			ctx.rotate(this.rotation * Math.PI / 180);
		}

		if (this.selected) {
			ctx.strokeStyle = "#000000";

			// show coverage area
			roundRect(ctx, -this.width / 2, -this.height / 2, this.width, this.height, 2);
			
			// show border of item
			// draw left top corner
			ctx.beginPath();
			ctx.arc(-this.width / 2, -this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.leftTop ? this.borderColor : this.defaultColor;
			ctx.fill();
			ctx.stroke();

			// draw right top corner
			ctx.beginPath();
			ctx.arc(this.width / 2, -this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.rightTop ? this.borderColor : this.defaultColor;
			ctx.fill();
			ctx.stroke();

			//draw left bottom corner
			ctx.beginPath();
			ctx.fillStyle = this.hoverCorners.leftBottom ? this.borderColor : this.defaultColor;
			ctx.arc(-this.width / 2, this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fill();
			ctx.stroke();

			//draw right bottom corner
			ctx.beginPath();
			ctx.arc(this.width / 2, this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.rightBottom ? this.borderColor : this.defaultColor;
			ctx.fill();
			ctx.stroke();

		}

		if (this.flipped) {
			ctx.scale(-1, 1);
		}

		ctx.drawImage(this.image, -this.width / 2, -this.height / 2, this.width, this.height);
		
		
		if (this.flipped) {
			ctx.scale(-1, 1);
		}
		
		ctx.restore();

		if (this.removed && this.removedIcon) {
			ctx.save();

			const { x, y } = this.originPoint;
			ctx.translate(x + canvasCenter.x, y + canvasCenter.y);
			if (this.rotation !== 0) {
				ctx.rotate(this.rotation * Math.PI / 180);
			}

			ctx.beginPath();
			ctx.fillStyle = 'rgba(100,100,100, 1)';
			ctx.arc(-this.width / 2, -this.height / 2, 10, 0, 2 * Math.PI);
			ctx.fill();
			ctx.drawImage(this.removedIcon, -this.width / 2 - 5, -this.height / 2 - 5, 10, 10);
			ctx.restore();
		}

	}

	//hit test for object
	collisionTest(coords) {
		/*return (pos.x >= this.originPoint.x - this.width / 2
			&& pos.x <= this.originPoint.x + this.width / 2
			&& pos.y >= this.originPoint.y - this.height / 2
			&& pos.y <= this.originPoint.y + this.height / 2)
			|| (this.hoverCorners.leftTop
				|| this.hoverCorners.leftBottom
				|| this.hoverCorners.rightTop
				|| this.hoverCorners.rightBottom
				|| this.hoverCorners.rotatePoint
			);*/

	console.log('collisionTest: img ' + this.originPoint.x + ',' + this.originPoint.y + '|| trash' + coords.x + ',' + coords.y)

		return !(
	        ((this.originPoint.y + this.height) < (coords.y)) ||	
	        (this.originPoint.y > (coords.y + coords.height)) ||
	        ((this.originPoint.x + this.width) < coords.x) ||
	        (this.originPoint.x > (coords.x + coords.width))
	    );
	}

	//hit test for mouse position realtive to ca (pos) vs 
	hitTest(pos) {
		return (pos.x >= this.originPoint.x - this.width / 2
			&& pos.x <= this.originPoint.x + this.width / 2
			&& pos.y >= this.originPoint.y - this.height / 2
			&& pos.y <= this.originPoint.y + this.height / 2)
			|| (this.hoverCorners.leftTop
				|| this.hoverCorners.leftBottom
				|| this.hoverCorners.rightTop
				|| this.hoverCorners.rightBottom
				|| this.hoverCorners.rotatePoint
			);
	}


	/*--------- imageItem coverage is checking that item is completely within boundary ---------------*/
	testCoverage() {

		// In case of metal Skin, coverage error msg is visible when entire signature is outside coverage area
		if(this.isMetalSkin) {
			const vertices = [this.getLeftBottomCorner(),
				this.getLeftTopCorner(),
				this.getRightTopCorner(),
				this.getRightBottomCorner()];
			
			const diagonal_vertices = [this.getLeftBottomCorner(),
				this.getRightTopCorner(),
				this.getLeftTopCorner(),
				this.getRightBottomCorner()];
	
			const bleedBox = {
				top: this.coverageArea.y,
				bottom: this.coverageArea.y + this.coverageArea.height,
				left: this.coverageArea.x,
				right: this.coverageArea.x + this.coverageArea.width
			};

			const image_data = {
				width: this.width,
				height: this.height
			}

			const r1 = allInside(vertices, this.coverageArea);
			const r2 = verticeOverlap(vertices, bleedBox);
			const r3 = anyLineIntersect(vertices, this.coverageArea); //this method is working correctly
			const r4 = diagonalIntersect(diagonal_vertices, bleedBox);

			this.errorCoverage = !(r1 || r2 || r3 || r4);

			const s1 = isSmallSignature(image_data, this.coverageArea);
			this.warningSize = s1;

			let messageFlag = {
				errorCoverage: this.errorCoverage,
				warningSize: this.warningSize
			}

			return messageFlag;
		}
		else {
			const vertices = [this.getLeftBottomCorner(),
			this.getRightTopCorner(),
			this.getLeftTopCorner(),
			this.getRightBottomCorner()];
			this.errorCoverage = !allInside(vertices, this.coverageArea);
	
			const OFFSET = 5;

			this.removed = this.originPoint.x + this.width / 2 < this.allowedArea.x - OFFSET
			|| this.originPoint.x - this.width / 2 > this.allowedArea.x + this.allowedArea.width + OFFSET
			|| this.originPoint.y + this.height / 2 < this.allowedArea.y - OFFSET
			|| this.originPoint.y - this.height / 2 > this.allowedArea.y + this.allowedArea.height + OFFSET;	
	
			// Show info message about delete the selected items
			const info = document.querySelector("#info-message");
			if(info){
				if (!this.removed) {
					info.classList.add('show');
				} else {
					info.classList.remove('show');
				}
			}
			
			return this.errorCoverage;
		}
	}

	handleResize(scale) {
		const ratio = this.width / this.height;
		this.width *= scale;
		this.height = this.width / ratio;

		this.originPoint = {
			x: this.originPoint.x * scale,
			y: this.originPoint.y * scale
		};

		this.coverageArea.x *= scale;
		this.coverageArea.y *= scale;
		this.coverageArea.width *= scale;
		this.coverageArea.height *= scale;

	}

	preview(scale, ctx) {

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		// Applied transparent coverage area to clip the image out of coverage area
		if(this.isMetalSkin) {
			this.makeTransparentCoverageRect(scale, ctx, canvasCenter);
		}

		const item = {
			image: this.image,
			width: this.width * scale.width,
			height: this.height * scale.height,
			rotation: this.rotation,
			flipped: this.flipped,
			originPoint: {
				x: this.originPoint.x * scale.width,
				y: this.originPoint.y * scale.height
			}
		};
		
		ctx.save();

		if(this.isMetalSkin) {
			ctx.translate(item.originPoint.x, item.originPoint.y);
		}
		else {
			ctx.translate(item.originPoint.x + canvasCenter.x, item.originPoint.y + canvasCenter.y);
		}
					
		if (item.rotation !== 0) {
			ctx.rotate(item.rotation * Math.PI / 180);
		}

		if (item.flipped) {
			ctx.scale(-1, 1);
		}

		ctx.drawImage(item.image, -item.width / 2, -item.height / 2, item.width, item.height);
		ctx.restore();

	}

	previewMetal(scale, ctx) {

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		const item = {
			//image: this.image,
			image:this.strokeImage,
			width: this.width * scale.width,
			height: this.height * scale.height,
			rotation: this.rotation,
			flipped: this.flipped,
			originPoint: {
				x: this.originPoint.x * scale.width,
				y: this.originPoint.y * scale.height
			}
		};	

		const previewCoverageArea = {
			x: (-canvasCenter.x + this.itemArea.Left * this.canvasScale * scale.width),
			y: (-canvasCenter.y + this.itemArea.Top * this.canvasScale * scale.height),
			width: ((this.itemArea.Right - this.itemArea.Left) * this.canvasScale * scale.width),
			height: ((this.itemArea.Bottom - this.itemArea.Top) * this.canvasScale * scale.height)
		};

		ctx.translate(canvasCenter.x, canvasCenter.y);

		ctx.drawImage(item.image, previewCoverageArea.x, previewCoverageArea.y, previewCoverageArea.width, previewCoverageArea.height);

		ctx.restore();
	}

	async setStrokeImage(url) {
		const img = new Image();
		img.crossOrigin = 'Anonymous';
		img.src = url;
		 return new Promise(resolve => {
			  img.onload = () => {				
				this.strokeImage = img;
				resolve(this.strokeImage);
			}
		});		
	}
	
	makeTransparentCoverageRect(scale, ctx, canvasCenter) {

		if(!this.itemArea) return;
		const previewCoverageArea = {
			x: (-canvasCenter.x + this.itemArea.Left * this.canvasScale * scale.width),
			y: (-canvasCenter.y + this.itemArea.Top * this.canvasScale * scale.height),
			width: ((this.itemArea.Right - this.itemArea.Left) * this.canvasScale * scale.width),
			height: ((this.itemArea.Bottom - this.itemArea.Top) * this.canvasScale * scale.height)
		};

		ctx.translate(canvasCenter.x, canvasCenter.y);

		// Used offset of 2px & 4px for CAN-458. Can remove this 'makeTransparentCoverageRect' method entirely once 'resize' & 'move' functionalities are scraped from every metal skin.
		roundRect(ctx, previewCoverageArea.x - 2, previewCoverageArea.y - 2, previewCoverageArea.width + 4, previewCoverageArea.height + 4, 2, 'transparent', 'transparent');
		ctx.clip();
		ctx.save();
	}

}

export default ImageItem;